import jQuery from 'jquery';

import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import template from 'lodash/template';
import forEach from 'lodash/forEach';
import deburr from 'lodash/deburr';
import merge from 'lodash/merge';

import * as bodyScrollLock from 'body-scroll-lock';
import scrollLock from "scroll-lock";

// Expose jQuery and Lodash functions.
window.$ = window.jQuery = jQuery;
const lodash = window._ = {
	throttle,
	debounce,
	template,
	forEach,
	deburr,
	merge,
};

const EN = window.EN = window.EN || {};
const EN_KO = window.EN_KO = window.EN_KO || {};
const EN_DEV = window.EN_DEV = window.EN_DEV || {};

if ( EN_DEV.Debug ) {
	EN_DEV.Debug.isActive = false;
}

EN_KO.deferredExecute = EN_KO.deferredExecute || [];
EN_KO.settings = EN_KO.settings || {};
EN_KO.elements = EN_KO.elements || {};
EN_KO.functions = EN_KO.functions || {};
EN_KO.to = EN_KO.to || {}; // timeouts
EN_KO.temp = EN_KO.temp || {};
EN_KO.lodash = lodash;

EN_KO.settings.isTouch = false;
EN_KO.settings.event = 'click';
EN_KO.settings.moveEvent = 'mousemove';

//conversion tracking
EN_KO.settings.conversionTrackingInitialized = false;


window.bodyScrollLock = bodyScrollLock;
window.scrollLock = scrollLock;

require( 'jquery-ui' );
require( 'jquery.cookie' );
require( 'jquery-serializejson' );


export {
	jQuery,
	lodash,
	EN,
	EN_KO,
	EN_DEV
}
